import axios from "axios";
import { useEffect, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";

const tableHeader = [
    { name: "Name", key: "fullName" , style:{whiteSpace:"nowrap"}},
    { name: "License Number", key: "licenseNumber", style:{whiteSpace:"nowrap"} },
    { name: "Company Name", key: "companyName", style:{whiteSpace:"nowrap"} },
    { name: "Role", key: "role", style:{whiteSpace:"nowrap"} },
    { name: "Plan", key: "plan", style:{whiteSpace:"nowrap"} },
    { name: "Issue", key: "issue", style:{whiteSpace:"nowrap"} },
    { name: "Expiry", key: "expiry", style:{whiteSpace:"nowrap"} },
    { name: "Email", key: "email", style:{whiteSpace:"nowrap"} },
    { name: "Phone", key: "phone", style:{whiteSpace:"nowrap"} },
];

function formatDate(date) {
    let d = new Date(date) ;
    if(d.toString() !== "Invalid Date") {
        return `${d.getDate()}/${d.getMonth()}/${d.getFullYear()}`
    }
    return date ;
}

const SubscriberList = () => {
    const [tableData, setTableData] = useState([]);
    const [fetchComplete, setFetchComplete] = useState(false);
    const [taskLoading, setTaskLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    const plan = {
        "BUSINESS_BUILDER_ID" : "Business Builder",
        "CORPORATE_PRICE_ID" : "Corporate",
        "STARTUP_PLAN_ID" : "Start Up"
    }

    function parseData(data) {
        let allFormData = [];
        console.log(data);
        
        data.forEach((formState) => {
            allFormData.push({
                fullName: formState.fullName,
                licenseNumber: formState.licenseNumber,
                role: formState.role,
                plan: plan[formState.plan] || formState.plan,
                issue: formatDate(formState.issue),
                expiry: formatDate(formState.expiry),
                companyName : formState.companyName,
                email : formState.email,
                phone : formState.mobileNumber,
            });
        });

        return allFormData;
    }

    useEffect(()=>{
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "getSubsciberData",
            headers: {
                token: authServices.getToken(),
            },
        };

        //console.log("CONFIG",config)

        axios(config)
            .then(function (response) {
                // console.log("subscribers", response.data);
                setFetchComplete(true);
                if(response.data.status === "success") {
                    let data = parseData(response.data.data);
                    setTableData(data);
                } 
            })
            .catch((error) => {
                setFetchComplete(true);
                console.error(error);
            });
    },[])

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Subscribers List</div>
                </div>
            </div>

            <div className="container-fluid p-3 pb-0">
                <div className="card p-4 border-0">
                    <div className="d-flex align-items-center">
                        <label htmlFor="search">Search for Subscribers : </label>
                        <div className="ms-3">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Type Name, Email , License Number"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="card p-3 border-0" >
                    {fetchComplete ? (
                        <div className="position-relative">

                            <div style={{overflowX:"auto"}}>
                                <DataTable 
                                    sortBy="timestampInSeconds" 
                                    reverseSort={true} 
                                    search={searchText} 
                                    header={tableHeader} 
                                    rawData={tableData} 
                                    paginate
                                />
                            </div>

                            {taskLoading && (
                                <div
                                    className="position-absolute top-0 left-0 w-100 h-100 bg-dark"
                                    style={{ zIndex: "99", opacity: "0.1", cursor: "wait" }}
                                ></div>
                            )}
                        </div>
                    ) : (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SubscriberList;
